export default {
  accountEnabled: { id: 'accountEnabled', dataType: 'boolean' },
  ageGroup: { id: 'ageGroup', dataType: 'string' },
  alternativeSecurityId: {
    id: 'alternativeSecurityId',
    dataType: 'string',
  },
  alternativeSecurityIds: {
    id: 'alternativeSecurityIds',
    dataType: 'string',
    // dataType: 'alternative securityId collection',
  },
  city: {
    id: 'city',
    dataType: 'string',
  },
  consentProvidedForMinor: {
    id: 'consentProvidedForMinor',
    dataType: 'string',
  },
  country: {
    id: 'country',
    dataType: 'string',
  },
  createdDateTime: {
    id: 'createdDateTime',
    dataType: 'string',
    // dataType: 'dateTime',
  },
  creationType: {
    id: 'creationType',
    dataType: 'string',
  },
  dateOfBirth: {
    id: 'dateOfBirth',
    dataType: 'string',
    // dataType: 'date',
  },
  department: {
    id: 'department',
    dataType: 'string',
  },
  displayName: {
    id: 'displayName',
    dataType: 'string',
  },
  facsimileTelephoneNumber: {
    id: 'facsimileTelephoneNumber',
    dataType: 'string',
  },
  givenName: {
    id: 'givenName',
    dataType: 'string',
  },
  jobTitle: {
    id: 'jobTitle',
    dataType: 'string',
  },
  immutableId: {
    id: 'immutableId',
    dataType: 'string',
  },
  legalAgeGroupClassification: {
    id: 'legalAgeGroupClassification',
    dataType: 'string',
  },
  legalCountry: {
    id: 'legalCountry',
    dataType: 'string',
  },
  mailNickName: {
    id: 'mailNickName',
    dataType: 'string',
  },
  mobile: {
    id: 'mobile',
    dataType: 'string',
  },
  netId: {
    id: 'netId',
    dataType: 'string',
  },
  objectId: {
    id: 'objectId',
    dataType: 'string',
  },
  otherMails: {
    id: 'otherMails',
    dataType: 'string',
    // dataType: 'string collection',
  },
  password: {
    id: 'password',
    dataType: 'string',
  },
  passwordPolicies: {
    id: 'passwordPolicies',
    dataType: 'string',
  },
  physicalDeliveryOfficeName: {
    id: 'physicalDeliveryOfficeName',
    dataType: 'string',
  },
  postalCode: {
    id: 'postalCode',
    dataType: 'string',
  },
  preferredLanguage: {
    id: 'preferredLanguage',
    dataType: 'string',
  },
  refreshTokensValidFromDateTime: {
    id: 'refreshTokensValidFromDateTime',
    dataType: 'string',
    // dataType: 'dateTime',
  },
  signInNames: {
    id: 'signInNames',
    dataType: 'string',
  },
  'signInNames.userName': {
    id: 'signInNames.userName',
    dataType: 'string',
  },
  'signInNames.phoneNumber': {
    id: 'signInNames.phoneNumber',
    dataType: 'string',
  },
  'signInNames.emailAddress': {
    id: 'signInNames.emailAddress',
    dataType: 'string',
  },
  state: {
    id: 'state',
    dataType: 'string',
  },
  streetAddress: {
    id: 'streetAddress',
    dataType: 'string',
  },
  strongAuthenticationAlternativePhoneNumber: {
    id: 'strongAuthenticationAlternativePhoneNumber',
    dataType: 'string',
  },
  strongAuthenticationEmailAddress: {
    id: 'strongAuthenticationEmailAddress',
    dataType: 'string',
  },
  strongAuthenticationPhoneNumber: {
    id: 'strongAuthenticationPhoneNumber',
    dataType: 'string',
  },
  surname: {
    id: 'surname',
    dataType: 'string',
  },
  telephoneNumber: {
    id: 'telephoneNumber',
    dataType: 'string',
  },
  userPrincipalName: {
    id: 'userPrincipalName',
    dataType: 'string',
  },
  usageLocation: {
    id: 'usageLocation',
    dataType: 'string',
  },
  userType: {
    id: 'userType',
    dataType: 'string',
  },
  userState: {
    id: 'userState',
    dataType: 'string',
  },
  userStateChangedOn: {
    id: 'userStateChangedOn',
    dataType: 'string',
    // dataType: 'dateTime',
  },
  userIdentities: {
    id: 'userIdentities',
    dataType: 'userIdentityCollection',
  },
};
